import { useEffect, useState } from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import {
  Box,
  Button,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { apiError } from '@bumble/app/utils/api-error';

interface RouterHandleServiceProps {
  cpeId: string;
  status: boolean;
  close: any;
  adminState?: string;
}
export const RouterHandleService = ({ cpeId, status, close, adminState }: RouterHandleServiceProps) => {
  const api = useApi();
  const [inProgress, setInProgress] = useState<boolean>(false);

  useEffect(() => {
    setInProgress(adminState === 'provisioned' || adminState === 'inactive' ? !status : status);
  }, [status, adminState]);

  const startService = useMutation(api.startCpeIpServiceApiV1StartCpeIpServicePost, {
    onSuccess(data) {
      const msg = 'status' in data.data
        ? data.data.status as string
        : `Activate Service Successfully.`;
      toast.success(msg);
      setTimeout(() => { close(); }, 1000);
    },
    onError: (error) => {
      apiError(error);
      setInProgress(false);
    },
  });

  const stopService = useMutation(api.stopCpeIpServiceApiV1StopCpeIpServicePost, {
    onSuccess(data) {
      const msg = 'status' in data.data
        ? data.data.status as string
        : `Stop Service Successfully.`;
      toast.success(msg);
      setTimeout(() => { close(); }, 1000);
    },
    onError: (error) => {
      apiError(error);
      setInProgress(false);
    },
  });

  const handleSubmit = () => {
    setInProgress(true);
    let data = { cpe_id: cpeId };
    status ? startService.mutate(data) : stopService.mutate(data);
  };

  return (
    <Box pt={2}>
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit} disabled={inProgress} >
          { status ? 'Activate' : 'Stop' }
        </Button>
      </Box>
    </Box>
  );
};
